<template>
<ol>
   <li v-for="breadcrumb in breadcrumbs" :key="breadcrumb.id">
      <router-link v-if="breadcrumb.path" :to="breadcrumb.path">{{breadcrumb.title}}</router-link>
      <a v-else-if="breadcrumb.url" :href="breadcrumb.url">{{breadcrumb.title}}</a>
      <template v-else>{{breadcrumb.title}}</template>
   </li>
</ol>
</template>

<script>
   import { mapState, mapGetters } from 'vuex'
   export default {
      data() {
         return { BaseURL }
      },
      computed: {
         ...mapGetters({
            breadcrumbs: 'global/breadcrumbs'
         }),
         // ...mapState({
         //    breadcrumbs: state => state.global.breadcrumbs
         // })
      },
      created() {
      }
   }
</script>

<style>
</style>
